const SUPPORTED_STEPS = {
  CONFIRMATION: 'confirmation',
  TRACKING_INTEGRATION: 'tracking',
  DRIVER: 'driver',
  TRUCK_INFO: 'truck-info',
  ALL_SET: 'all-set',
}

const supportedStepNames = Object.values(SUPPORTED_STEPS)

const stepsConfig = {
  SUPPORTED_STEPS,
  supportedStepNames,
}

export { SUPPORTED_STEPS, supportedStepNames, stepsConfig }
